<template>
    <div>
        <v-data-table v-if="items.length > 0" :items="items" :headers="headers">
            <template v-slot:item="props">
                <tr>
                    <td v-for="(header, index) in headers"
                        :key="index"
                        :class="all(props.index) ? 'red lighten-1' : propRequired(header.value,props.index)">
                        <span>{{ props.item[header.value] }}</span>
                    </td>
                </tr>
            </template>
        </v-data-table>
    </div>
</template>
<script>
    export default {
        props: {
            items: {
                default: () => [],
                type: Array
            },
            properties: {
                default: () => [],
                type: Array
            }
        },
        data: () => ({
            headers: [
                {
                    text: "EmpCode",
                    value: "empCode",
                    sortable: false
                },
                {
                    text: "Movement Type",
                    value: "movementType",
                    sortable: false
                },
                /*RLV:30Jun2022*/
                {
                    text: "Movement Type Details",
                    value: "movTypeDet",
                    sortable: false
                },
                {
                    text: "Employee Category",
                    value: "empCat",
                    sortable: false
                },
                {
                    text: "Rank",
                    value: "rank",
                    sortable: false
                },
                {
                    text: "Location Code",
                    value: "locCode",
                    sortable: false
                },
                {
                    text: "Division Code",
                    value: "divCode",
                    sortable: false
                },
                {
                    text: "Department Code",
                    value: "depCode",
                    sortable: false
                },
                {
                    text: "Unit Code",
                    value: "unitCode",
                    sortable: false
                },
                {
                    text: "Area Code",
                    value: "areaCode",
                    sortable: false
                },
                {
                    text: "Section Code",
                    value: "secCode",
                    sortable: false
                },
                {
                    text: "Group Code",
                    value: "groupCode",
                    sortable: false
                },
                {
                    text: "Branch Code",
                    value: "branchCode",
                    sortable: false
                },
                {
                    text: "Pay House",
                    value: "subAcctCode",
                    sortable: false
                },
                {
                    text: "Designation Code",
                    value: "desCode",
                    sortable: false
                },
                {
                    text: "Salary Classification Code",
                    value: "clsCode",
                    sortable: false
                },
                {
                    text: "Region Code",
                    value: "regCode",
                    sortable: false
                },
                {
                    text: "Payroll Location ID",
                    value: "locId",
                    sortable: false
                },
                {
                    text: "Tax Code",
                    value: "taxCode",
                    sortable: false
                },
                {
                    text: "Bank Account",
                    value: "bankAccount",
                    sortable: false
                },
                {
                    text: "Bank Code",
                    value: "bankCode",
                    sortable: false
                },
                {
                    text: "SSS No",
                    value: "sssNo",
                    sortable: false
                },
                {
                    text: "Philhealth No",
                    value: "pHilHealthNo",
                    sortable: false
                },
                {
                    text: "Pagibig No",
                    value: "pagibigNo",
                    sortable: false
                },
                {
                    text: "TIN",
                    value: "tin",
                    sortable: false
                },
                {
                    text: "Pagibig Code",
                    value: "pagibigCode",
                    sortable: false
                },
                {
                    text: "Tax Flag",
                    value: "taxFlag",
                    sortable: false
                },
                {
                    text: "CompBonusFLag",
                    value: "compBonusFlag",
                    sortable: false
                },
                {
                    text: "SSS Flag",
                    value: "sssFlag",
                    sortable: false
                },
                {
                    text: "PagFlag",
                    value: "pagFlag",
                    sortable: false
                },
                {
                    text: "PhilFlag",
                    value: "philFlag",
                    sortable: false
                },
                {
                    text: "Bonus13thFlag",
                    value: "bonus13thFlag",
                    sortable: false
                },
                {
                    text: "Bank Account Type",
                    value: "bankAccountType",
                    sortable: false
                },
                {
                    text: "Salary For Check",
                    value: "salaryForCheck",
                    sortable: false
                },
                {
                    text: "Salary on Hold",
                    value: "salaryOnHold",
                    sortable: false
                },
                {
                    text: "Project Code",
                    value: "projectCode",
                    sortable: false
                },
                {
                    text: "IsContractual",
                    value: "isContractual",
                    sortable: false
                },
                {
                    text: "Endorsed By",
                    value: "endorsedBy",
                    sortable: false
                },
                {
                    text: "MemberID",
                    value: "memberID",
                    sortable: false
                },
                {
                    text: "GSIS No",
                    value: "gsisNo",
                    sortable: false
                },
                {
                    text: "OnlineApp Code",
                    value: "onlineAppCode",
                    sortable: false
                },
                /*RLV:30Jun2022*/
                {
                    text: "PagibigVoluntary Start Date",
                    value: "pagVolSDate",
                    sortable: false
                }
            ]
        }),
        computed: {},
        methods: {
            propRequired(prop, index) {
                var result = this.properties.filter(item => {
                    // console.log(item.property.toLowerCase());
                    // console.log(item.index);
                    return (
                        item.property.toLowerCase() == prop.toLowerCase() &&
                        item.mode == "EMPINFO" &&
                        item.index == index
                    );
                });

                if (result.length > 0) return "red lighten-1";
                else return "";
            },
            all(index) {
                var result = this.properties.filter(item => {
                    return (
                        item.property == "ALL" &&
                        item.mode == "EMPINFO" &&
                        item.index == index
                    );
                });
                if (result.length > 0) return true;
                else false;
            }
        }
    };
</script>